import { createReducer, on } from "@ngrx/store";
import { TableComponentState } from "../../shared/types/TableComponentState";
import { StandingAuthCheckActions, StandingAuthInternalTransferActions, StandingAuthWireActions } from "../actions";
import { TweActions } from "../../create-request/actions";

export const tweTableStateKey = 'tweTableState';

export interface State extends TableComponentState {
}

export const initialTweTableState: State = {
    loading: false,
    error: '',
    hasError: false,
    gridReady: false,
    isInitialLoad: true,
    printClicked: false
};

export const tweTableStateReducer = createReducer(
    initialTweTableState,
    on(TweActions.gridReady, (state, action) => {
        return {
            ...state,
            gridReady: action.gridReady
        }
    }),
    on(StandingAuthInternalTransferActions.verifyCallSuccessful,
        StandingAuthWireActions.verifyV3CallSuccessful,
        StandingAuthInternalTransferActions.loadInternalTransferReviewPageWithoutVerifyCall,
        StandingAuthWireActions.loadWiresReviewPageWithoutVerifyCall,
        StandingAuthCheckActions.loadChecksReviewPageWithoutVerifyCall,
        StandingAuthCheckActions.verifyCallSuccessful, (state) => {
            return {
                ...state,
                loading: false,
                hasError: false,
            };
        }),
    on(StandingAuthInternalTransferActions.verifyCallFail,
        StandingAuthCheckActions.verifyCallFailed, (state, err) => {
            return {
                ...state,
                loading: false,
                error: err.message,
                hasError: true,
            };
        })
);
